/**
 * Generated by orval v8.7.0 🍺
 * Do not edit manually.
 * Agentiq.Api | v1
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CredentialRecord,
  DescriptorsRequest,
  GetCredentialRequest,
  ModelCatalogRequest,
  ProviderDescriptorRecordDto,
  SaveCredentialRequest,
  TenantAiProviderConnectionRecordDto,
  TenantAiProviderConnectionValidationResultDto,
  TenantAiProviderModelCatalogResponseDto,
  ValidateProviderConnectionRequest
} from '../control-api.schemas';

import { orvalControlFetch } from '../../orval-fetcher';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getGetApiAiProviderConnectionsUrl = () => {




  return `/api/ai-provider-connections`
}

export const getApiAiProviderConnections = async ( options?: RequestInit): Promise<TenantAiProviderConnectionRecordDto[]> => {

  return orvalControlFetch<TenantAiProviderConnectionRecordDto[]>(getGetApiAiProviderConnectionsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetApiAiProviderConnectionsQueryKey = () => {
    return [
    `/api/ai-provider-connections`
    ] as const;
    }


export const getGetApiAiProviderConnectionsQueryOptions = <TData = Awaited<ReturnType<typeof getApiAiProviderConnections>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAiProviderConnections>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiAiProviderConnectionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiAiProviderConnections>>> = ({ signal }) => getApiAiProviderConnections({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiAiProviderConnections>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiAiProviderConnectionsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiAiProviderConnections>>>
export type GetApiAiProviderConnectionsQueryError = unknown


export function useGetApiAiProviderConnections<TData = Awaited<ReturnType<typeof getApiAiProviderConnections>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAiProviderConnections>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiAiProviderConnections>>,
          TError,
          Awaited<ReturnType<typeof getApiAiProviderConnections>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiAiProviderConnections<TData = Awaited<ReturnType<typeof getApiAiProviderConnections>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAiProviderConnections>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiAiProviderConnections>>,
          TError,
          Awaited<ReturnType<typeof getApiAiProviderConnections>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiAiProviderConnections<TData = Awaited<ReturnType<typeof getApiAiProviderConnections>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAiProviderConnections>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiAiProviderConnections<TData = Awaited<ReturnType<typeof getApiAiProviderConnections>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAiProviderConnections>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiAiProviderConnectionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getPostApiAiProviderConnectionsUrl = () => {




  return `/api/ai-provider-connections`
}

export const postApiAiProviderConnections = async (tenantAiProviderConnectionRecordDto: TenantAiProviderConnectionRecordDto, options?: RequestInit): Promise<TenantAiProviderConnectionRecordDto> => {

  return orvalControlFetch<TenantAiProviderConnectionRecordDto>(getPostApiAiProviderConnectionsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      tenantAiProviderConnectionRecordDto,)
  }
);}




export const getPostApiAiProviderConnectionsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAiProviderConnections>>, TError,{data: TenantAiProviderConnectionRecordDto}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiAiProviderConnections>>, TError,{data: TenantAiProviderConnectionRecordDto}, TContext> => {

const mutationKey = ['postApiAiProviderConnections'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiAiProviderConnections>>, {data: TenantAiProviderConnectionRecordDto}> = (props) => {
          const {data} = props ?? {};

          return  postApiAiProviderConnections(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiAiProviderConnectionsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiAiProviderConnections>>>
    export type PostApiAiProviderConnectionsMutationBody = TenantAiProviderConnectionRecordDto
    export type PostApiAiProviderConnectionsMutationError = unknown

    export const usePostApiAiProviderConnections = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAiProviderConnections>>, TError,{data: TenantAiProviderConnectionRecordDto}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiAiProviderConnections>>,
        TError,
        {data: TenantAiProviderConnectionRecordDto},
        TContext
      > => {
      return useMutation(getPostApiAiProviderConnectionsMutationOptions(options), queryClient);
    }
    export const getDeleteApiAiProviderConnectionsIdUrl = (id: string,) => {




  return `/api/ai-provider-connections/${id}`
}

export const deleteApiAiProviderConnectionsId = async (id: string, options?: RequestInit): Promise<void> => {

  return orvalControlFetch<void>(getDeleteApiAiProviderConnectionsIdUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteApiAiProviderConnectionsIdMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiAiProviderConnectionsId>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiAiProviderConnectionsId>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteApiAiProviderConnectionsId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiAiProviderConnectionsId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteApiAiProviderConnectionsId(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiAiProviderConnectionsIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiAiProviderConnectionsId>>>

    export type DeleteApiAiProviderConnectionsIdMutationError = unknown

    export const useDeleteApiAiProviderConnectionsId = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiAiProviderConnectionsId>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiAiProviderConnectionsId>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteApiAiProviderConnectionsIdMutationOptions(options), queryClient);
    }
    export const getPostApiAiProviderConnectionsValidateUrl = () => {




  return `/api/ai-provider-connections/validate`
}

export const postApiAiProviderConnectionsValidate = async (validateProviderConnectionRequest: ValidateProviderConnectionRequest, options?: RequestInit): Promise<TenantAiProviderConnectionValidationResultDto> => {

  return orvalControlFetch<TenantAiProviderConnectionValidationResultDto>(getPostApiAiProviderConnectionsValidateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      validateProviderConnectionRequest,)
  }
);}




export const getPostApiAiProviderConnectionsValidateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAiProviderConnectionsValidate>>, TError,{data: ValidateProviderConnectionRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiAiProviderConnectionsValidate>>, TError,{data: ValidateProviderConnectionRequest}, TContext> => {

const mutationKey = ['postApiAiProviderConnectionsValidate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiAiProviderConnectionsValidate>>, {data: ValidateProviderConnectionRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiAiProviderConnectionsValidate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiAiProviderConnectionsValidateMutationResult = NonNullable<Awaited<ReturnType<typeof postApiAiProviderConnectionsValidate>>>
    export type PostApiAiProviderConnectionsValidateMutationBody = ValidateProviderConnectionRequest
    export type PostApiAiProviderConnectionsValidateMutationError = unknown

    export const usePostApiAiProviderConnectionsValidate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAiProviderConnectionsValidate>>, TError,{data: ValidateProviderConnectionRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiAiProviderConnectionsValidate>>,
        TError,
        {data: ValidateProviderConnectionRequest},
        TContext
      > => {
      return useMutation(getPostApiAiProviderConnectionsValidateMutationOptions(options), queryClient);
    }
    export const getPostApiAiProviderConnectionsCredentialSaveUrl = () => {




  return `/api/ai-provider-connections/credential/save`
}

export const postApiAiProviderConnectionsCredentialSave = async (saveCredentialRequest: SaveCredentialRequest, options?: RequestInit): Promise<CredentialRecord> => {

  return orvalControlFetch<CredentialRecord>(getPostApiAiProviderConnectionsCredentialSaveUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      saveCredentialRequest,)
  }
);}




export const getPostApiAiProviderConnectionsCredentialSaveMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAiProviderConnectionsCredentialSave>>, TError,{data: SaveCredentialRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiAiProviderConnectionsCredentialSave>>, TError,{data: SaveCredentialRequest}, TContext> => {

const mutationKey = ['postApiAiProviderConnectionsCredentialSave'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiAiProviderConnectionsCredentialSave>>, {data: SaveCredentialRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiAiProviderConnectionsCredentialSave(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiAiProviderConnectionsCredentialSaveMutationResult = NonNullable<Awaited<ReturnType<typeof postApiAiProviderConnectionsCredentialSave>>>
    export type PostApiAiProviderConnectionsCredentialSaveMutationBody = SaveCredentialRequest
    export type PostApiAiProviderConnectionsCredentialSaveMutationError = unknown

    export const usePostApiAiProviderConnectionsCredentialSave = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAiProviderConnectionsCredentialSave>>, TError,{data: SaveCredentialRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiAiProviderConnectionsCredentialSave>>,
        TError,
        {data: SaveCredentialRequest},
        TContext
      > => {
      return useMutation(getPostApiAiProviderConnectionsCredentialSaveMutationOptions(options), queryClient);
    }
    export const getPostApiAiProviderConnectionsCredentialGetUrl = () => {




  return `/api/ai-provider-connections/credential/get`
}

export const postApiAiProviderConnectionsCredentialGet = async (getCredentialRequest: GetCredentialRequest, options?: RequestInit): Promise<CredentialRecord> => {

  return orvalControlFetch<CredentialRecord>(getPostApiAiProviderConnectionsCredentialGetUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      getCredentialRequest,)
  }
);}




export const getPostApiAiProviderConnectionsCredentialGetMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAiProviderConnectionsCredentialGet>>, TError,{data: GetCredentialRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiAiProviderConnectionsCredentialGet>>, TError,{data: GetCredentialRequest}, TContext> => {

const mutationKey = ['postApiAiProviderConnectionsCredentialGet'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiAiProviderConnectionsCredentialGet>>, {data: GetCredentialRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiAiProviderConnectionsCredentialGet(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiAiProviderConnectionsCredentialGetMutationResult = NonNullable<Awaited<ReturnType<typeof postApiAiProviderConnectionsCredentialGet>>>
    export type PostApiAiProviderConnectionsCredentialGetMutationBody = GetCredentialRequest
    export type PostApiAiProviderConnectionsCredentialGetMutationError = unknown

    export const usePostApiAiProviderConnectionsCredentialGet = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAiProviderConnectionsCredentialGet>>, TError,{data: GetCredentialRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiAiProviderConnectionsCredentialGet>>,
        TError,
        {data: GetCredentialRequest},
        TContext
      > => {
      return useMutation(getPostApiAiProviderConnectionsCredentialGetMutationOptions(options), queryClient);
    }
    export const getPostApiAiProviderConnectionsModelCatalogUrl = () => {




  return `/api/ai-provider-connections/model-catalog`
}

export const postApiAiProviderConnectionsModelCatalog = async (modelCatalogRequest: ModelCatalogRequest, options?: RequestInit): Promise<TenantAiProviderModelCatalogResponseDto> => {

  return orvalControlFetch<TenantAiProviderModelCatalogResponseDto>(getPostApiAiProviderConnectionsModelCatalogUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      modelCatalogRequest,)
  }
);}




export const getPostApiAiProviderConnectionsModelCatalogMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAiProviderConnectionsModelCatalog>>, TError,{data: ModelCatalogRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiAiProviderConnectionsModelCatalog>>, TError,{data: ModelCatalogRequest}, TContext> => {

const mutationKey = ['postApiAiProviderConnectionsModelCatalog'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiAiProviderConnectionsModelCatalog>>, {data: ModelCatalogRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiAiProviderConnectionsModelCatalog(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiAiProviderConnectionsModelCatalogMutationResult = NonNullable<Awaited<ReturnType<typeof postApiAiProviderConnectionsModelCatalog>>>
    export type PostApiAiProviderConnectionsModelCatalogMutationBody = ModelCatalogRequest
    export type PostApiAiProviderConnectionsModelCatalogMutationError = unknown

    export const usePostApiAiProviderConnectionsModelCatalog = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAiProviderConnectionsModelCatalog>>, TError,{data: ModelCatalogRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiAiProviderConnectionsModelCatalog>>,
        TError,
        {data: ModelCatalogRequest},
        TContext
      > => {
      return useMutation(getPostApiAiProviderConnectionsModelCatalogMutationOptions(options), queryClient);
    }
    export const getPostApiProvidersDescriptorsUrl = () => {




  return `/api/providers/descriptors`
}

export const postApiProvidersDescriptors = async (descriptorsRequestNull: DescriptorsRequest | null, options?: RequestInit): Promise<ProviderDescriptorRecordDto[]> => {

  return orvalControlFetch<ProviderDescriptorRecordDto[]>(getPostApiProvidersDescriptorsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      descriptorsRequestNull,)
  }
);}




export const getPostApiProvidersDescriptorsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiProvidersDescriptors>>, TError,{data: DescriptorsRequest | null}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiProvidersDescriptors>>, TError,{data: DescriptorsRequest | null}, TContext> => {

const mutationKey = ['postApiProvidersDescriptors'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiProvidersDescriptors>>, {data: DescriptorsRequest | null}> = (props) => {
          const {data} = props ?? {};

          return  postApiProvidersDescriptors(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiProvidersDescriptorsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiProvidersDescriptors>>>
    export type PostApiProvidersDescriptorsMutationBody = DescriptorsRequest | null
    export type PostApiProvidersDescriptorsMutationError = unknown

    export const usePostApiProvidersDescriptors = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiProvidersDescriptors>>, TError,{data: DescriptorsRequest | null}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiProvidersDescriptors>>,
        TError,
        {data: DescriptorsRequest | null},
        TContext
      > => {
      return useMutation(getPostApiProvidersDescriptorsMutationOptions(options), queryClient);
    }
